export default __webpack_public_path__ + "static/media/banner1.9bf51510.webp";